import { Steps } from 'antd';
import { FC } from 'react';
import { Wrapper } from './styles';

type Props = {
  currentStep: number;
  backStepPrevious: () => void;
};
const HeaderBillingRegister: FC<Props> = ({ currentStep }) => {
  const { Step } = Steps;

  return (
    <Wrapper>
      <div className="header1">
        <div className="wrap-step">
          <Steps type="navigation" size="small" current={currentStep} className="site-navigation-steps">
            <Step title="受診状況登録" />
            <Step title="CPAP利用明細作成" />
            <Step title="出張PSG検査明細作成" />
            <Step title="簡易検査明細作成" />
            <Step title="その他明細作成" />
            <Step title="請求内容登録" />
            <Step className="last" title="登録完了" />
          </Steps>
        </div>
      </div>
    </Wrapper>
  );
};

export default HeaderBillingRegister;
